import { z } from 'zod';

export const NotificationsMassNotificationScalarFieldEnumSchema = z.enum(['id','city_id','content_id','author_id','message','progress','total','created_at','updated_at','channels','scheduled_at','billingTransactionId']);

export default NotificationsMassNotificationScalarFieldEnumSchema;
